import { render } from "./AddPrivilegeModal.vue?vue&type=template&id=1b685ab6&ts=true"
import script from "./AddPrivilegeModal.vue?vue&type=script&lang=ts"
export * from "./AddPrivilegeModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__